// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.invoicetypes', {
        url: '/invoicetypes?searchTerm',
        views: {
            'baseList': {
            templateUrl: 'main/base/invoicetypes/invoicetypes.tpl.html',
            controller: 'InvoiceTypesController as vm'
        }},
        resolve: {
            invoicetypes: invoicetypesResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function invoicetypesResolver(InvoiceTypesApiService, $stateParams) {
    return InvoiceTypesApiService.getInvoiceTypes({ page: 0, searchTerm:$stateParams.searchTerm, pageSize:null});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function InvoiceTypesController($rootScope, $state, $scope, invoicetypes, InvoiceTypesApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.invoicetypes = invoicetypes;
    vm.selectedInvoiceTypeId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.invoiceTypeId; }, function(newValue, oldValue) {
            vm.selectedInvoiceTypeId = parseInt($state.params.invoiceTypeId,10);
        });
        $rootScope.$on('InvoiceType.Inserted', function(event, response) {
        });
        $rootScope.$on('InvoiceType.Updated', function(event, response) {
        });
        $rootScope.$on('InvoiceType.Deleted', function(event, response) {
        });
        $rootScope.$on('InvoiceType.Changed', function(event, response) {
            loadInvoiceTypes();
        });
    }

    function loadInvoiceTypes() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        InvoiceTypesApiService.getInvoiceTypes(request).then(function(response) {
            vm.invoicetypes = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadInvoiceTypes();
    }

}

angular
    .module('base.invoicetypes', ['invoicetypes.api','invoicetypes.invoicetype'])
    .config(stateConfig)
    .controller('InvoiceTypesController', InvoiceTypesController);
